export enum COUNTRY_NAMES {
  AFGHANISTAN = 'Afghanistan',
  ALAND_ISLANDS = 'Aland Islands',
  ALBANIA = 'Albania',
  ALGERIA = 'Algeria',
  AMERICAN_SAMOA = 'American Samoa',
  ANDORRA = 'Andorra',
  ANGOLA = 'Angola',
  ANGUILLA = 'Anguilla',
  ANTARCTICA = 'Antarctica',
  ANTIGUA_AND_BARBUDA = 'Antigua and Barbuda',
  ARGENTINA = 'Argentina',
  ARMENIA = 'Armenia',
  ARUBA = 'Aruba',
  AUSTRALIA = 'Australia',
  AUSTRIA = 'Austria',
  AZERBAIJAN = 'Azerbaijan',
  BAHAMAS = 'Bahamas',
  BAHRAIN = 'Bahrain',
  BANGLADESH = 'Bangladesh',
  BARBADOS = 'Barbados',
  BELARUS = 'Belarus',
  BELGIUM = 'Belgium',
  BELIZE = 'Belize',
  BENIN = 'Benin',
  BERMUDA = 'Bermuda',
  BHUTAN = 'Bhutan',
  BOLIVIA = 'Bolivia',
  BONAIRE_SAINT_EUSTATIUS_AND_SABA = 'Bonaire, Saint Eustatius and Saba',
  BOSNIA_AND_HERZEGOVINA = 'Bosnia and Herzegovina',
  BOTSWANA = 'Botswana',
  BOUVET_ISLAND = 'Bouvet Island',
  BRAZIL = 'Brazil',
  BRITISH_INDIAN_OCEAN_TERRITORY = 'British Indian Ocean Territory',
  BRUNEI_DARUSSALAM = 'Brunei Darussalam',
  BULGARIA = 'Bulgaria',
  BURKINA_FASO = 'Burkina Faso',
  BURUNDI = 'Burundi',
  CAMBODIA = 'Cambodia',
  CAMEROON = 'Cameroon',
  CANADA = 'Canada',
  CANARY_ISLANDS = 'Canary Islands',
  CAPE_VERDE = 'Cape Verde',
  CAYMAN_ISLANDS = 'Cayman Islands',
  CENTRAL_AFRICAN_REPUBLIC = 'Central African Republic',
  CEUTA_AND_MELILLA = 'Ceuta and Melilla',
  CHAD = 'Chad',
  CHILE = 'Chile',
  CHINA = 'China',
  CHRISTMAS_ISLAND = 'Christmas Island',
  COCOS_ISLANDS = 'Cocos (Keeling) Islands',
  COLOMBIA = 'Colombia',
  COMOROS = 'Comoros',
  DEMOCRATIC_REPUBLIC_OF_CONGO = 'Congo, Democratic Republic of',
  REPUBLIC_OF_CONGO = 'Congo, Republic of',
  COOK_ISLANDS = 'Cook Islands',
  COSTA_RICA = 'Costa Rica',
  COTE_DIVOIRE = "Cote d'Ivoire",
  CROATIA = 'Croatia',
  CUBA = 'Cuba',
  CURAÇAO = 'Curaçao',
  CYPRUS = 'Cyprus',
  CZECH_REPUBLIC = 'Czech Republic',
  DENMARK = 'Denmark',
  DJIBOUTI = 'Djibouti',
  DOMINICA = 'Dominica',
  DOMINICAN_REPUBLIC = 'Dominican Republic',
  EAST_TIMOR = 'East Timor',
  ECUADOR = 'Ecuador',
  EGYPT = 'Egypt',
  EL_SALVADOR = 'El Salvador',
  EQUATORIAL_GUINEA = 'Equatorial Guinea',
  ERITREA = 'Eritrea',
  ESTONIA = 'Estonia',
  ETHIOPIA = 'Ethiopia',
  FALKLAND_ISLANDS = 'Falkland Islands',
  FAROE_ISLANDS = 'Faroe Islands',
  FIJI = 'Fiji',
  FINLAND = 'Finland',
  FRANCE = 'France',
  FRENCH_GUIANA = 'French Guiana',
  FRENCH_POLYNESIA = 'French Polynesia',
  FRENCH_SOUTHERN_TERRITORIES = 'French Southern Territories',
  GABON = 'Gabon',
  GAMBIA = 'Gambia',
  GEORGIA = 'Georgia',
  GERMANY = 'Germany',
  GHANA = 'Ghana',
  GIBRALTAR = 'Gibraltar',
  GREECE = 'Greece',
  GREENLAND = 'Greenland',
  GRENADA = 'Grenada',
  GUADELOUPE = 'Guadeloupe',
  GUAM = 'Guam',
  GUATEMALA = 'Guatemala',
  GUERNSEY = 'Guernsey',
  GUINEA = 'Guinea',
  GUINEA_BISSAU = 'Guinea-Bissau',
  GUYANA = 'Guyana',
  HAITI = 'Haiti',
  HEARD_AND_MCDONALD_ISLANDS = 'Heard and McDonald Islands',
  VATICAN = 'Holy See (City Vatican State)',
  HONDURAS = 'Honduras',
  HONG_KONG = 'Hong Kong',
  HUNGARY = 'Hungary',
  ICELAND = 'Iceland',
  INDIA = 'India',
  INDONESIA = 'Indonesia',
  IRAN = 'Iran (Islamic Republic of)',
  IRAQ = 'Iraq',
  IRELAND = 'Ireland',
  ISLE_OF_MAN = 'Isle of Man',
  ISRAEL = 'Israel',
  ITALY = 'Italy',
  JAMAICA = 'Jamaica',
  JAPAN = 'Japan',
  JERSEY = 'Jersey',
  JORDAN = 'Jordan',
  KAZAKHSTAN = 'Kazakhstan',
  KENYA = 'Kenya',
  KIRIBATI = 'Kiribati',
  DEMOCRATIC_REPUBLIC_KOREA = "Korea, Democratic People's Republic",
  REPUBLIC_OF_KOREA = 'Korea, Republic of',
  KOSOVO = 'Kosovo',
  KUWAIT = 'Kuwait',
  KYRGYZSTAN = 'Kyrgyzstan',
  LAO_PEOPLE_DEMOCRATIC_REPUBLIC = "Lao People's Democratic Republic",
  LATVIA = 'Latvia',
  LEBANON = 'Lebanon',
  LESOTHO = 'Lesotho',
  LIBERIA = 'Liberia',
  LIBYA = 'Libya',
  LIECHTENSTEIN = 'Liechtenstein',
  LITHUANIA = 'Lithuania',
  LUXEMBOURG = 'Luxembourg',
  MACAU = 'Macau',
  MACEDONIA = 'Macedonia',
  MADAGASCAR = 'Madagascar',
  MALAWI = 'Malawi',
  MALAYSIA = 'Malaysia',
  MALDIVES = 'Maldives',
  MALI = 'Mali',
  MALTA = 'Malta',
  MARSHALL_ISLANDS = 'Marshall Islands',
  MARTINIQUE = 'Martinique',
  MAURITANIA = 'Mauritania',
  MAURITIUS = 'Mauritius',
  MAYOTTE = 'Mayotte',
  MEXICO = 'Mexico',
  FEDERAL_STATE_OF_MICRONESIA = 'Micronesia, Federal State of',
  REPUBLIC_OF_MOLDOVA = 'Moldova, Republic of',
  MONACO = 'Monaco',
  MONGOLIA = 'Mongolia',
  MONTENEGRO = 'Montenegro',
  MONTSERRAT = 'Montserrat',
  MOROCCO = 'Morocco',
  MOZAMBIQUE = 'Mozambique',
  MYANMAR = 'Myanmar (Burma)',
  NAMIBIA = 'Namibia',
  NAURU = 'Nauru',
  NEPAL = 'Nepal',
  NETHERLANDS = 'Netherlands',
  NETHERLANDS_ANTILLES = 'Netherlands Antilles (Deprecated)',
  NEW_CALEDONIA = 'New Caledonia',
  NEW_ZEALAND = 'New Zealand',
  NICARAGUA = 'Nicaragua',
  NIGER = 'Niger',
  NIGERIA = 'Nigeria',
  NIUE = 'Niue',
  NORFOLK_ISLAND = 'Norfolk Island',
  NORTHERN_MARIANA_ISLANDS = 'Northern Mariana Islands',
  NORWAY = 'Norway',
  OMAN = 'Oman',
  PAKISTAN = 'Pakistan',
  PALAU = 'Palau',
  PANAMA = 'Panama',
  PAPUA_NEW_GUINEA = 'Papua New Guinea',
  PARAGUAY = 'Paraguay',
  PERU = 'Peru',
  PHILIPPINES = 'Philippines',
  PITCAIRN_ISLAND = 'Pitcairn Island',
  POLAND = 'Poland',
  PORTUGAL = 'Portugal',
  PUERTO_RICO = 'Puerto Rico',
  QATAR = 'Qatar',
  REUNION_ISLAND = 'Reunion Island',
  ROMANIA = 'Romania',
  RUSSIAN_FEDERATION = 'Russian Federation',
  RWANDA = 'Rwanda',
  SAINT_BARTHÉLEMY = 'Saint Barthélemy',
  SAINT_HELENA = 'Saint Helena',
  SAINT_KITTS_AND_NEVIS = 'Saint Kitts And Nevis',
  SAINT_LUCIA = 'Saint Lucia',
  SAINT_MARTIN = 'Saint Martin',
  SAINT_VINCENT_AND_THE_GRENADINES = 'Saint Vincent and the Grenadines',
  SAMOA = 'Samoa',
  SAN_MARINO = 'San Marino',
  SAO_TOME_AND_PRINCIPE = 'Sao Tome and Principe',
  SAUDI_ARABIA = 'Saudi Arabia',
  SENEGAL = 'Senegal',
  SERBIA = 'Serbia',
  SERBIA_AND_MONTENEGRO = 'Serbia and Montenegro (Deprecated)',
  SEYCHELLES = 'Seychelles',
  SIERRA_LEONE = 'Sierra Leone',
  SINGAPORE = 'Singapore',
  SINT_MAARTEN = 'Sint Maarten',
  SLOVAK_REPUBLIC = 'Slovak Republic',
  SLOVENIA = 'Slovenia',
  SOLOMON_ISLANDS = 'Solomon Islands',
  SOMALIA = 'Somalia',
  SOUTH_AFRICA = 'South Africa',
  SOUTH_GEORGIA = 'South Georgia',
  SOUTH_SUDAN = 'South Sudan',
  SPAIN = 'Spain',
  SRI_LANKA = 'Sri Lanka',
  ST_PIERRE_AND_MIQUELON = 'St. Pierre and Miquelon',
  STATE_OF_PALESTINE = 'State of Palestine',
  SUDAN = 'Sudan',
  SURINAME = 'Suriname',
  SVALBARD_AND_JAN_MAYEN_ISLANDS = 'Svalbard and Jan Mayen Islands',
  SWAZILAND = 'Swaziland',
  SWEDEN = 'Sweden',
  SWITZERLAND = 'Switzerland',
  SYRIAN_ARAB_REPUBLIC = 'Syrian Arab Republic',
  TAIWAN = 'Taiwan',
  TAJIKISTAN = 'Tajikistan',
  TANZANIA = 'Tanzania',
  THAILAND = 'Thailand',
  TOGO = 'Togo',
  TOKELAU = 'Tokelau',
  TONGA = 'Tonga',
  TRINIDAD_AND_TOBAGO = 'Trinidad and Tobago',
  TUNISIA = 'Tunisia',
  TURKEY = 'Turkiye',
  TURKMENISTAN = 'Turkmenistan',
  TURKS_AND_CAICOS_ISLANDS = 'Turks and Caicos Islands',
  TUVALU = 'Tuvalu',
  UGANDA = 'Uganda',
  UKRAINE = 'Ukraine',
  UNITED_ARAB_EMIRATES = 'United Arab Emirates',
  UNITED_KINGDOM = 'United Kingdom',
  UNITED_STATES = 'United States',
  URUGUAY = 'Uruguay',
  US_MINOR_OUTLYING_ISLANDS = 'US Minor Outlying Islands',
  UZBEKISTAN = 'Uzbekistan',
  VANUATU = 'Vanuatu',
  VENEZUELA = 'Venezuela',
  VIETNAM = 'Vietnam',
  VIRGIN_ISLANDS_BRITISH = 'Virgin Islands (British)',
  VIRGIN_ISLANDS_USA = 'Virgin Islands (USA)',
  WALLIS_AND_FUTUNA = 'Wallis And Futuna',
  WESTERN_SAHARA = 'Western Sahara',
  YEMEN = 'Yemen',
  ZAMBIA = 'Zambia',
  ZIMBABWE = 'Zimbabwe',
}